import { generateTypes } from '../../utils/HttpReducerHelper';

const entitiesBatch = generateTypes('MONITOR', 'ENTITIES_BATCH');
const companiesSnapshots = generateTypes('MONITOR', 'COMPANIES_SNAPSHOTS');
const updateCompanyMap = generateTypes('MONITOR', 'UPDATE_COMPANY_MAP');
const postCompanyMap = generateTypes('MONITOR', 'POST_COMPANY_MAP');
const POST_CONNECTED_COMPANIES = 'platfi-ui-app/MONITOR/POST_CONNECTED_COMPANIES';
const ADD_COMPANY_TO_IMPORT = 'platfi-ui-app/MONITOR/ADD_COMPANY_TO_IMPORT';
const ADD_COMPANIES_LIST_TO_IMPORT = 'platfi-ui-app/MONITOR/ADD_COMPANIES_LIST_TO_IMPORT';
const REMOVE_COMPANY_FROM_IMPORT = 'platfi-ui-app/MONITOR/REMOVE_COMPANY_FROM_IMPORT';
const CLEAR_COMPANIES_LIST_IMPORT = 'platfi-ui-app/MONITOR/CLEAR_COMPANIES_LIST_IMPORT';
const SSE_UPDATE_BATCH_PROGRESS = '@@SSE/snapshots/batch/progress_updated';

export {
  entitiesBatch,
  postCompanyMap,
  updateCompanyMap,
  companiesSnapshots,
  ADD_COMPANY_TO_IMPORT,
  POST_CONNECTED_COMPANIES,
  ADD_COMPANIES_LIST_TO_IMPORT,
  REMOVE_COMPANY_FROM_IMPORT,
  CLEAR_COMPANIES_LIST_IMPORT,
  SSE_UPDATE_BATCH_PROGRESS,
};
